module.exports = __webpack_public_path__ + "img/task-4-g.8636b1ae.png";